var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.$style.topbar},[_c('v-col',[_c('div',{class:_vm.$style.tabActive},[_vm._v(_vm._s(_vm.$t('ALL_COMPANIES')))])]),_c('v-col',{class:_vm.$style.searchEnterprise})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }